export const heroStats = [
  { label: "Árvores georreferenciadas", value: "12.486", icon: "ri-plant-line" },
  { label: "Vistorias técnicas", value: "2.156", icon: "ri-clipboard-line" },
  { label: "Áreas verdes monitoradas", value: "64", icon: "ri-landscape-line" },
  { label: "Relatórios ambientais", value: "847", icon: "ri-file-chart-line" },
];

export const aboutCards = [
  {
    title: "Cadastro Técnico Arbóreo",
    description: "Registre cada árvore com código CTA único, georreferenciamento, fotos, FCA e histórico técnico completo.",
    icon: "ri-plant-line",
    color: "bg-primary-50 text-primary-600",
  },
  {
    title: "Gestão Ambiental Urbana",
    description: "Monitore áreas verdes, praças, parques, APPs urbanas e Unidades de Conservação integradas ao inventário.",
    icon: "ri-landscape-line",
    color: "bg-accent-50 text-accent-600",
  },
  {
    title: "Inteligência Territorial GIS",
    description: "Visualize, filtre e analise o patrimônio verde no mapa com camadas de risco, espécie, bairro e projeto.",
    icon: "ri-map-pin-line",
    color: "bg-primary-50 text-primary-600",
  },
];

export const solutions = [
  {
    title: "CTA — Cadastro Técnico Arbóreo",
    description: "Registro técnico individual por árvore com código CTA único, coordenadas UTM, endereço, fotos e evidências.",
    icon: "ri-barcode-line",
  },
  {
    title: "FCA — Ficha Cadastral Arbórea",
    description: "Ficha individual completa com dados botânicos, fitossanitários, risco, DAP, altura, copa e recomendações.",
    icon: "ri-file-text-line",
  },
  {
    title: "Mapa Arbóreo GIS",
    description: "Mapa interativo com filtros por risco, espécie, bairro, projeto e status. Exportação GeoJSON e integração PostGIS.",
    icon: "ri-map-line",
  },
  {
    title: "Vistorias e Monitoramento",
    description: "Vistorias técnicas periódicas com estado fitossanitário, classificação de risco, recomendação e fotos.",
    icon: "ri-search-line",
  },
  {
    title: "Fotos e Evidências",
    description: "Armazenamento de fotos de campo, documentos técnicos, laudos e evidências vinculados a cada árvore e projeto.",
    icon: "ri-camera-line",
  },
  {
    title: "Áreas Verdes e UCs",
    description: "Cadastro de praças, parques, APPs urbanas e Unidades de Conservação com polígonos, árvores internas e documentos.",
    icon: "ri-shield-line",
  },
  {
    title: "Carbono e Ativos Ambientais",
    description: "Estimativa preliminar de biomassa, carbono e CO₂e com modelos alométricos para apoio a ESG e sustentabilidade.",
    icon: "ri-cloud-line",
  },
  {
    title: "Relatórios Técnicos",
    description: "Geração automatizada de relatórios de inventário, vistoria, risco, manejo e ambiental em múltiplos formatos.",
    icon: "ri-bar-chart-line",
  },
];

export const audiences = [
  { label: "Prefeituras", icon: "ri-building-line" },
  { label: "Secretarias de Meio Ambiente", icon: "ri-leaf-line" },
  { label: "Loteadoras", icon: "ri-map-pin-line" },
  { label: "Condomínios", icon: "ri-community-line" },
  { label: "Consultorias Ambientais", icon: "ri-user-line" },
  { label: "Empresas com Obrigações Ambientais", icon: "ri-briefcase-line" },
  { label: "Gestores de Parques e Áreas Verdes", icon: "ri-tree-line" },
  { label: "Órgãos Públicos de Meio Ambiente", icon: "ri-building-2-line" },
];

export const ctaFeatures = [
  "Cadastrar árvores com código CTA único",
  "Registrar localização georreferenciada",
  "Gerar Ficha Cadastral Arbórea (FCA) individual",
  "Armazenar fotos, evidências e documentos",
  "Avaliar fitossanidade e classificar risco",
  "Recomendar manejo técnico por árvore",
  "Acompanhar histórico e vistorias periódicas",
  "Gerar relatórios técnicos automatizados",
];

export const gisFeatures = [
  "Mapa arbóreo com camadas temáticas",
  "Filtros por risco, espécie, bairro e projeto",
  "Visualização de áreas verdes e UCs",
  "Destaque de árvores críticas no território",
  "Exportação GeoJSON para integração",
  "Estrutura preparada para PostGIS",
  "Sobreposição de dados cadastrais e ambientais",
  "Análise espacial de risco urbano",
];

export const carbonFeatures = [
  "Estimativa preliminar de CO₂e sequestrado",
  "Cálculo de biomassa arbórea",
  "Mapeamento de áreas verdes e UCs",
  "Monitoramento de compensações ambientais",
  "Controle de replantios e adensamento",
  "Indicadores ambientais urbanos",
  "Apoio a metas ESG e sustentabilidade",
  "Relatórios de impacto ambiental",
];

export const benefits = [
  { title: "Decisão baseada em dados", description: "Informações técnicas confiáveis para embasar decisões de manejo, remoção e replantio." },
  { title: "Redução de risco urbano", description: "Identificação e monitoramento de árvores com risco de queda, poda e interferência." },
  { title: "Organização do inventário", description: "Base técnica única, georreferenciada e permanente do patrimônio arbóreo da cidade." },
  { title: "Histórico técnico por árvore", description: "Toda a vida útil documentada: plantio, vistorias, manejos, pragas, doenças e remoções." },
  { title: "Relatórios automáticos", description: "Relatórios de inventário, vistoria, risco, manejo e compensação em poucos cliques." },
  { title: "Gestão de áreas verdes", description: "Cadastro de praças, parques, corredores verdes e UCs com polígonos e indicadores." },
  { title: "Transparência ambiental", description: "Dados abertos ao cidadão e aos órgãos de controle sobre o patrimônio verde urbano." },
  { title: "Base para cidades inteligentes", description: "Estrutura georreferenciada pronta para integração com sistemas urbanos e IoT." },
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Criar projeto",
    description: "Defina o escopo, município, equipe e cronograma do inventário ou monitoramento ambiental.",
    icon: "ri-folder-add-line",
  },
  {
    step: 2,
    title: "Cadastrar árvores e áreas",
    description: "Colete dados de campo com georreferenciamento, fotos, medidas e identificação botânica.",
    icon: "ri-plant-line",
  },
  {
    step: 3,
    title: "Realizar vistorias",
    description: "Aplique vistorias técnicas periódicas avaliando fitossanidade, risco e necessidade de manejo.",
    icon: "ri-clipboard-line",
  },
  {
    step: 4,
    title: "Analisar riscos e indicadores",
    description: "Visualize árvores críticas, indicadores de carbono, áreas verdes e compensações no mapa GIS.",
    icon: "ri-bar-chart-line",
  },
  {
    step: 5,
    title: "Gerar relatórios e decisões",
    description: "Exporte relatórios técnicos, indicadores e dados para apoiar decisões públicas e privadas.",
    icon: "ri-file-chart-line",
  },
];

export const demoStats = [
  { label: "Árvores cadastradas", value: "12.486", change: "+421 este mês" },
  { label: "Vistorias realizadas", value: "2.156", change: "+127 este mês" },
  { label: "Árvores em risco crítico", value: "87", change: "-12 após manejo" },
  { label: "Projetos ativos", value: "18", change: "4 em Goiânia" },
];

export const riskChartData = [
  { label: "Baixo", value: 7134, percent: 57.1, color: "bg-primary-500" },
  { label: "Médio", value: 3845, percent: 30.8, color: "bg-caution-500" },
  { label: "Alto", value: 1420, percent: 11.4, color: "bg-warning-500" },
  { label: "Crítico", value: 87, percent: 0.7, color: "bg-danger-500" },
];

export const navLinks = [
  { label: "Plataforma", href: "#plataforma" },
  { label: "Soluções", href: "#solucoes" },
  { label: "CTA Arbóreo", href: "#cta-arboreo" },
  { label: "Ambiental", href: "#ambiental" },
  { label: "Carbono", href: "#carbono" },
  { label: "Relatórios", href: "#relatorios" },
];

export const footerLinks = [
  { label: "Plataforma", href: "#plataforma" },
  { label: "Soluções", href: "#solucoes" },
  { label: "CTA Arbóreo", href: "#cta-arboreo" },
  { label: "Ambiental", href: "#ambiental" },
  { label: "Carbono", href: "#carbono" },
  { label: "Relatórios", href: "#relatorios" },
];